import moment from 'moment'
import 'moment/locale/de'
import React from 'react'
import { render } from 'react-dom'
import Cookies from 'js-cookie'

import App from './App'
import registerServiceWorker from './registerServiceWorker'

const startup = () => {
  moment.locale('de')

  render(<App />, document.getElementById('root'))

  registerServiceWorker()
}

const abihomeCookie = Cookies.get('Abihome')

if (abihomeCookie) {
  startup()
} else {
  window.location = 'https://landing.abihome.de/login/customer-center'
}



// WEBPACK FOOTER //
// ./src/index.js